import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "ngxRemoveSpacers",
})
export class RemoveSpacersPipe implements PipeTransform {
    transform(value: string): any {
        if (!value || typeof value !== "string") return "";

        return value.replace(/\s/g, "");
    }
}
